import { ICharacterOutlineByUser } from '../../../../../interfaces/book.interface';
import { StoryCharacterEnum } from '../../../../../interfaces/character.interface';

export const validateCharacter = (characterOutlineByUser: ICharacterOutlineByUser): boolean => {
  const isHumanValid =
    characterOutlineByUser?.characterType === StoryCharacterEnum.human &&
    characterOutlineByUser?.age &&
    characterOutlineByUser?.ageUnit &&
    characterOutlineByUser?.gender;
    // characterOutlineByUser?.mics;

  const isAnimalValid =
    characterOutlineByUser?.characterType === StoryCharacterEnum.animal &&
    characterOutlineByUser?.animalType &&
    characterOutlineByUser?.mics;

  const isFictionalValid =
    characterOutlineByUser?.characterType === StoryCharacterEnum.fictional &&
    characterOutlineByUser?.character &&
    characterOutlineByUser?.mics;

  return Boolean(isHumanValid) || Boolean(isAnimalValid) || Boolean(isFictionalValid);
};
